import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import monkeyImage from "@/assets/404-monkey.webp";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | TodoTomorrow</title>
        <meta name="description" content="Oops! The page you're looking for seems to have gone on a jungle adventure." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex min-h-screen items-center justify-center bg-background px-4 py-8">
        <div className="text-center max-w-2xl mx-auto">
          {/* 404 Text */}
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="relative mb-8"
          >
            <h1 
              className="text-[120px] sm:text-[180px] md:text-[220px] font-bold leading-none"
              style={{
                color: '#F4C430',
                textShadow: '4px 4px 0px #E6B800, 8px 8px 0px rgba(230, 184, 0, 0.3)',
                WebkitTextStroke: '3px #E6B800'
              }}
            >
              404
            </h1>
          </motion.div>

          {/* Monkey Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative mb-8 -mt-20"
          >
            <img 
              src={monkeyImage} 
              alt="Sad monkey with blue beanie" 
              className="w-48 sm:w-64 md:w-80 mx-auto drop-shadow-2xl"
              width="500"
              height="500"
            />
          </motion.div>

          {/* Page Not Found */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6"
            style={{ color: '#5D4037' }}
          >
            Page Not Found
          </motion.h2>

          {/* Bananas Message */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4"
            style={{ color: '#5D4037' }}
          >
            🍌Ohh bananas🍌
          </motion.p>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-base sm:text-lg md:text-xl text-muted-foreground mb-8"
          >
            Maybe the page went on the jungle adventure.
          </motion.p>

          {/* Go Back Home Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            <Link to="/">
              <Button 
                size="lg"
                className="text-base sm:text-lg px-8 py-6 rounded-full font-semibold"
                style={{
                  backgroundColor: '#4A90E2',
                  color: 'white'
                }}
              >
                Go Back Home
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
